import { StepType } from '@wix/ambassador-online-programs-v3-step/types';
import { batchFetchOnlineProgramsCoverImages } from './fetch-online-programs-cover-images';
import { fetchOnlineProgramsInstructors } from './fetch-online-programs-instructors';
import { fetchOnlineProgramsQuizzes } from './fetch-online-programs-quiz-steps';
import { batchFetchOnlineProgramsSteps } from './fetch-online-programs-steps';
export const fetchOnlinePrograms = async (httpClient, errorHandler, ids) => {
  const onlineProgramsCoverImageData = await batchFetchOnlineProgramsCoverImages(httpClient, errorHandler, ids);
  const programsId = onlineProgramsCoverImageData.onlinePrograms.map(program => program.id);
  const queryInstructorsPromise = fetchOnlineProgramsInstructors(httpClient, errorHandler, programsId);
  const queryStepsPromise = batchFetchOnlineProgramsSteps(httpClient, errorHandler, programsId);
  const [queryStepsResponse, queryInstructorsResponse] = await Promise.allSettled([queryStepsPromise, queryInstructorsPromise]);
  const instructorsData = queryInstructorsResponse.status === 'fulfilled' ? queryInstructorsResponse.value : {
    imagesInstructorsMap: {},
    instructors: []
  };
  const stepsData = queryStepsResponse.status === 'fulfilled' ? queryStepsResponse.value : {
    imagesToStepMap: {},
    quizIdToStepId: {},
    stepIdToStepMap: new Map(),
    steps: []
  };
  const quizSteps = stepsData.steps.filter(_ref => {
    let {
      stepType
    } = _ref;
    return stepType === StepType.QUIZ;
  });
  const quizData = await fetchOnlineProgramsQuizzes(httpClient, errorHandler, quizSteps);
  return {
    onlineProgramsCoverImageData,
    onlineProgramsInstructorsData: instructorsData,
    onlineProgramsQuizStepsData: quizData,
    onlineProgramsStepsData: stepsData
  };
};
//# sourceMappingURL=fetch-online-programs.js.map